import { render, staticRenderFns } from "./select-add-on.vue?vue&type=template&id=54af6b29"
import script from "./select-add-on.vue?vue&type=script&lang=js"
export * from "./select-add-on.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports